import { createPortal } from 'react-dom'


const OContextMenu = (props: any) => {
  const { children, onClose } = props

  const content = <div className='backdrop' onClick={() => onClose()}>
    <div onClick={(e) => e.stopPropagation()}>{children}</div>
  </div>

  return createPortal(content, document.body)
}

export default OContextMenu
